import { Link } from 'react-router-dom';
import { ProductOnboardingBanner } from '../onboarding/ProductOnboardingBanner';
import { useProductOnboardingStatus, isProductOnboardingActive } from '../../hooks/useProductOnboarding';

export function FeedEmptyState() {
  const { data: productStatus } = useProductOnboardingStatus();
  const showBanner = isProductOnboardingActive(productStatus?.phase);

  return (
    <div
      className="mx-auto max-w-md space-y-4 py-10 text-center"
      data-testid="feed-empty-state"
    >
      <p className="text-muted-foreground">
        Nothing on the Live Feed yet. Posts appear when the work engine starts
        an initiative or project, when work completes, or when someone posts
        from Chat.
      </p>
      {showBanner ? <ProductOnboardingBanner /> : null}
      <div className="flex flex-col items-stretch gap-2 sm:flex-row sm:justify-center">
        <Link
          to="/chat"
          data-testid="feed-empty-chat"
          className="rounded-md bg-secondary px-3 py-2 text-sm font-medium text-secondary-foreground hover:bg-secondary/80"
        >
          Chat
        </Link>
        <Link
          to="/orgchart"
          data-testid="feed-empty-orgchart"
          className="rounded-md bg-secondary px-3 py-2 text-sm font-medium text-secondary-foreground hover:bg-secondary/80"
        >
          Org Chart
        </Link>
      </div>
    </div>
  );
}
